export const POPOVER_CONSTANTS = {
    ANIMATION_DELAY: 160
};
